import * as actions from './assetMaster/actions'
import * as mutations from './assetMaster/mutations'
import * as getters from './assetMaster/getters'

import { dataProps } from './assetMaster/properties'

const state = {
    list: [],
    nav: {
        page_number: 1, 
        had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 'asset_name',
        sort_direction: 0, search_term: '', 
        search_term_array: []
    },
    props: JSON.parse(JSON.stringify(dataProps))    
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/assetMaster.js